import { IDataEvent } from "@multiweb/types/contracts";

/**
 * Listener pro DataEvent
 * @includeToDoc
 */
export type DataEventListener = (dataEvent: IDataEvent) => void;

/**
 * Komunikační klient, který umožňuje vytvořit trvalý obousměrný komunikační kanál s webovou službou.
 * Konzument si může registrovat poslouchání různým typům zpráv.
 * Webová služba mu pak může v reálném čase tyto zprávy posílat.
 * @includeToDoc
 */
export interface IDataEventsClient {
    /**
     * Registrace naslouchání obecnému DataEventu
     * @param source Pojmenování zdroje zpráv (pro sytémové zprávy je to "OW", pro ostatní podle jejich nastavení)
     * @param type Typ zprávy
     * @param subType Volitelný podtyp zprávy - může zpřesňovat naslouchání jen menší množině zpráv ("*" značí naslouchání všemu)
     * @param listener Listener volaný při obdržení zprávy
     */
    subscribeDataEvent(source: string, type: string, subType: string, listener: DataEventListener): void;
    /**
     * Odregistrování naslouchání obecnému DataEventu
     * @param source Pojmenování zdroje zpráv (pro sytémové zprávy je to "OW", pro ostatní podle jejich nastavení)
     * @param type Typ zprávy
     * @param subType Volitelný podtyp zprávy - může zpřesňovat naslouchání jen menší množině zpráv ("*" značí naslouchání všemu)
     * @param listener Listener použitý při registraci. Pokud není vyplněn, tak jsou odregistrovany vsechny listenery pro daný DataEvent
     */
    unsubscribeDataEvent(source: string, type: string, subType: string, listener?: DataEventListener): void;
}
